import type { Permission} from "./permission";
import { permissions } from "./permission";
import type { Scope } from "./scope";

/**
 * Parses scope into resource path segments and a permission
 * @param {Scope} scope
 * @return {*}  {{ segments: string[]; permission: Permission }}
 */
const parseScope = (
    scope: Scope
): { segments: string[]; permission: Permission } => {
    if (!scope.trim())
        throw new Error("Invalid scope, scope must not be empty");
    if (permissions.every(permission => !scope.endsWith(`:${permission}`))) {
        throw new Error("Invalid scope, must end with a permission; " + scope);
    }
    const segments = scope.split(":").filter(Boolean);
    const permission: Permission = segments.pop() as Permission;

    return {
        segments,
        permission,
    };
};
export { parseScope };
